/* 
 * 车辆离线报警计划 
 * 描述： 
 * 创建时间：2017-04-10 
 * 创建人：baixx 
 * 修改时间：2017-04-11 
 */
<template>
	<div id="statusAlarmOffline" class="wrapper wrapper-content animated fadeInRight tabBox">
		<div class="ibox-content" v-loading="loadingstatus.home||loadingstatus.base||loadingstatus.mode||loadingstatus.period||loadingstatus.monitor" element-loading-text="加载中">
			<!--头部导航模块-->
			<div class="row">
				<div class="col-sm-12">
					<div class="alarm_process_icon">
						<ul>
							<li :class="{ active: stepOneActive, 'finish': !stepOneActive && stepOneStatus }"><i class="icon iconfont icon-jibenxinxi"></i><span>基本信息</span></li>
							<li :class="{ active: stepTwoActive, 'finish': !stepTwoActive && stepTwoStatus }"><i class="icon iconfont icon-baojingfangshi"></i><span>报警方式</span></li>
							<li :class="{ active: stepThreeActive, 'finish': !stepThreeActive && stepThreeStatus }"><i class="icon iconfont icon-jiankongquyu"></i><span>监控区域</span></li>
							<li :class="{ active: stepFourActive, 'finish': !stepFourActive && stepFourStatus }"><i class="icon iconfont icon-jiankongshiduan"></i><span>监控时段</span></li>
							<li :class="{ active: stepFiveActive, 'finish': !stepFiveActive && stepFiveStatus }"><i class="icon iconfont icon-jiankongcheliang"></i><span>监控车辆</span></li>
							<li :class="{ active: stepSixActive }"><i class="icon iconfont icon-wancheng"></i><span>完成</span></li>
						</ul>
					</div>
				</div>
			</div>
			<!--step-1:基本信息模块-->
			<div :style="{ display: stepOneActive?'block':'none' }">
				<AlarmPlanBase v-model="alarmBaseInfo" :imageData="imgdata" title="车辆离线报警" systemAlarms="当车辆的定位设备发生离线，并超出约定的时限时，触发系统报警。" bgClass="alarm_list_bg07"></AlarmPlanBase>
			</div>
			<!--step-2:报警方式模块-->
			<div :style="{ display: stepTwoActive?'block':'none' }">
				<AlarmPlanMode v-model="alarmModeInfo" :parentid="pageid"></AlarmPlanMode>
			</div>
			<!--step-3:监控区域模块-->
			<div :style="{ display: stepThreeActive?'block':'none' }">
					<div class="row">
						<div class="col-sm-12 ">
							<div class="module_title"> <span class="focus_color">请指定报警监控区域</span> </div>
						</div>
					</div>
					<div class="row">
						<form role="form" class="form-inline">
							<div class="col-sm-1 text-right">
								<div class="form-group pt5px mr30px">
									<label class="focus_color">报警范围</label>
								</div>
							</div>
							<div class="col-sm-8">
								<div class="form-group pt5px mr30px">
	                                <label>
	                                	<radio v-model="alarmAreaInfo.limitOf" true-value="0">不限地域</radio>
	            					</label>
	                            </div>
	                            <div class="form-group pt5px mr30px">
	                                <label>
	                                	<radio v-model="alarmAreaInfo.limitOf" true-value="1">仅限特定地域</radio>
	            					</label>
	                            </div>
					        </div>
					    </form>   
					</div>  
				
				<!--不限地域-->
				<div class="row" v-if="alarmAreaInfo.limitOf=='0'">
					<form role="form" class="form-inline grey_box ofh pt10px">
						<div class="col-sm-1 text-right">
							<div class="form-group pt5px mr30px" style="margin-top: 2px;">
								<label class="focus_color">报警触发敏感度</label>
							</div>
						</div>
						<div class="col-sm-8">	
							<div class="form-group pt5px mr30px">
                                <label>
                                	<radio v-model="alarmAreaInfo.trigger" true-value="0">立即触发</radio>
            					</label>
                            </div>	
                            <div class="form-group pt5px mr30px">
                                <label>
                                	<radio v-model="alarmAreaInfo.trigger" true-value="1">车辆离线</radio>
            					</label>
		                    </div>
		                    <div class="form-group pt5px mr30px" style="margin-top: -6px;">
		                    	<input-number v-model="alarmAreaInfo.vehicleMinut" :min="0" :max="100000" :controls="false" :inputWidth="90" :disabled="onlimit"></input-number>
		                    	<span>分钟后</span>
		                    </div>
                        </div>
				    </form>
			    </div>	
		        <!--仅限特定区域-->
                <div class="row" v-if="alarmAreaInfo.limitOf=='1' && mode!=2">
					<div class="form-horizontal">
						<div class="form-group">
							<label class="col-sm-2 control-label">电子围栏名称</label>
							<div class="col-sm-4" >	
								<div class="input-group">
                                    <input type="text" class="form-control" v-model.trim="alarmAreaInfo.alarmAreaParam.areaName"> 
                                    <span class="input-group-btn"> 
                                    	<button type="button" v-if="permission.indexOf('statusAlarmOffline_monitorAreaSelect') == -1" class="btn btn-primary" @click="fellInfoSearch">查询</button> 
                                    </span>
                                </div>
                                <p class="help-block focus_color" v-if="alarmAreaInfo.areaTipStatis">未找到对应的电子围栏名称，请更换其它查询条件再试。</p>
							</div>
							<span class="col-sm-6 control-label gray t_left">注：您可以通过“监控平台” --- “围栏”图标，建立新的电子围栏。</span>
						</div>
					</div>
				</div>
				<!--查询围栏部分-->
				<div class="row" v-if="alarmAreaInfo.areaStatis">
					<form role="form" class="form-inline grey_box ofh pt10px">
						<div class="col-sm-2 text-right">
							<div class="form-group pt5px">
								<label class="focus_color">区域触发敏感度</label>
							</div>
						</div>
						<div class="col-sm-8">
							<div class="form-group pt5px">
                                <label>
                                	<radio v-model="alarmAreaInfo.speciallyTrigger" true-value="0">立即触发</radio>
            					</label>
                            </div>
                            <div class="form-group pt5px">
	                            <label>
	                            	<radio v-model="alarmAreaInfo.speciallyTrigger" true-value="1">车辆离线</radio>
            					</label>
	                        </div>
	                        <input-number v-model="alarmAreaInfo.speciallyVehicleMinut" :min="0" :max="100000" :controls="false" :inputWidth="90" :disabled="speciallyOnlimit"></input-number>
                            <div class="form-group">
								<span>分钟后</span>
							</div>
						</div>
						
						<div class="col-sm-2 text-right">
							<div class="form-group">
                        		<button type="button" class="btn btn-primary" @click="hideFellInfo">隐藏查询结果</button>
                        	</div>
						</div>
						
						<table class="table mt20px table-striped table-bordered">
							<thead>
								<tr>
									<th>电子围栏名称</th>
									<th>电子围栏面积</th>
									<th>围栏创建人</th>
									<th>围栏创建时间</th>
									<th>备注</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(fileInfo,index) in alarmAreaInfo.areaList" v-bind:key="index">
									<td>{{fileInfo.areaName}}</td>
									<td><span v-if = "fileInfo.areaSize!=0">{{fileInfo.areaSize}}㎡</span></td>
									<td>{{fileInfo.createName}}</td>
									<td>{{fileInfo.createTime}}</td>
									<td>{{fileInfo.memo}}</td>
									<td class="text-center">
										<a v-if="permission.indexOf('statusAlarmOffline_monitorAreaAdd') == -1" class="text-center" @click="addFellInfo(index)">添加</a>
									</td>
								</tr>
							</tbody>
						</table>
						<!--分页组件开始-->
						<pagination  v-if="alarmAreaInfo.areaList.length>0" :pageInfo="alarmAreaInfo.pageInfo" v-on:getData="getFellInfoPageNo"></pagination>
						<!--分页组件结束-->
                    </form>
                </div>
				<!--添加围栏部分-->
				<div class="row" v-if="alarmAreaInfo.limitOf=='1'">
					<table class="table mt20px table-striped table-bordered">
							<thead>
								<tr>
									<th v-if="mode!=2"></th>
									<th>电子围栏名称</th>
									<th>电子围栏面积</th>
									<th class="focus_color">触发敏感度</th>
									<th>围栏创建人</th>
									<th>围栏创建时间</th>
									<th>备注</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(fileInfo,index) in alarmAreaInfo.areaAddList" v-bind:key="index">
									<td class="text-center" v-if="mode!=2">
										<a v-if="permission.indexOf('statusAlarmOffline_monitorAreaDelete') == -1" class="text-center" @click="removeFellInfo(index)"><i class="glyphicon glyphicon-trash"></i></a>
									</td>
									<td>{{fileInfo.areaName}}</td>
									<td><span v-if = "fileInfo.areaSize!=0">{{fileInfo.areaSize}}㎡</span></td>
									<td>{{fileInfo.triggerCount==0?'立即':fileInfo.triggerCount+'分钟'}}</td>
									<td>{{fileInfo.createName}}</td>
									<td>{{fileInfo.createTime}}</td>
									<td>{{fileInfo.memo}}</td>
								</tr>
							</tbody>
					</table>
				</div>
			</div>	
        
       
			<!--step-4:监控时段模块-->
			<div :style="{ display: stepFourActive?'block':'none' }">
				<AlarmPlanPeriod v-model="alarmPeriodInfo" :parentid="pageid"></AlarmPlanPeriod>
			</div>
			<!--step-5:监控车辆模块-->
			<div :style="{ display: stepFiveActive?'block':'none' }">
				<AlarmPlanMonitor v-model="alarmMonitorInfo" :typeid="typeid"></AlarmPlanMonitor>
			</div>
			<!--step-6:完成-->
			<div :style="{ display: stepSixActive?'block':'none' }">
				<ul>
				  <li v-for="item in checkList" class="focus_color">
				    {{ item.step + ':' + item.message }}
				  </li>
				</ul>
			</div>
			<!--页脚控制部分-->
			<div class="row">
				<div class="col-sm-12 text-center pt10px">
					<button type="button" class="btn btn-primary " v-if="preBtnStatus" :disabled="operStatus" @click="preStep">上一步</button>
					<button type="button" class="btn btn-primary " v-if="nextBtnStatus" @click="nextStep">下一步</button>
					<button type="button" class="btn btn-primary " v-if="mode!=2 && finishBtnStatus" :disabled="operStatus" @click="saveAllInfo">{{operStatus?'保存完成':'保存'}}</button>
				</div>
			</div>
			<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
		</div>
	</div>
</template>

<script>
	import Pagination from 'components/common/Pagination'
	import {ALARM_ICON_IN} from 'static/constant'
	import InputNumber from 'components/common/InputNumber'
	import Radio from 'components/common/Radio'
	import Checkbox from 'components/common/Checkbox'
	import TabModal from 'components/common/TabModal'
	import AlarmPlanBase from 'components/pages/vehiclealarm/common/AlarmPlanBase'
	import AlarmPlanMode from 'components/pages/vehiclealarm/common/AlarmPlanMode'
	import AlarmPlanPeriod from 'components/pages/vehiclealarm/common/AlarmPlanPeriod'
	import AlarmPlanMonitor from 'components/pages/vehiclealarm/common/AlarmPlanMonitor'
	import { OPERATE_SUCCESS,OPERATE_EXCEPTION} from 'static/message'
	import classlist from 'util/classlist'
	import {isPhone} from 'util/util'
	
	export default {
		name: 'PageStatusAlarmOffline',
		components: {
			Pagination,
			InputNumber,
			Radio,
			Checkbox,
			TabModal,
			AlarmPlanBase,
			AlarmPlanMode,
			AlarmPlanPeriod,
			AlarmPlanMonitor
		},
		// 接收参数
		created(){
			this.mode = this.$route.query.mode;
			this.planid = this.$route.query.planid;
		},
		data() {
			return {
				permission:this.$store.state.permission.permission[this.parentid]?this.$store.state.permission.permission[this.parentid]:[],
				loadingstatus:{
					home:false,
					base:false,
					mode:false,
					period:false,
					monitor:false
				},
				pageid:'statusAlarmOffline',
				operStatus:false,				  //操作状态
				typeid:'8',
				planid:'',						  //报警计划ID
				mode:'0',						  //当前操作模式0：新建 1：编辑
				imgdata:ALARM_ICON_IN,
				stepIndex:1,                      //当前步骤索引
				stepMaxIndex:1,					  //最大步骤索引
				stepOneStatus:false,              //基本信息完成状态
				stepTwoStatus:false,              //报警方式完成状态
				stepThreeStatus:false,            //监控区域完成状态
				stepFourStatus:false,             //监控时段完成状态
				stepFiveStatus:false,             //监控车辆完成状态
				//基本信息
				alarmBaseInfo: {
				},
				//报警方式
				alarmModeInfo: {
				},
				//监控区域
				alarmAreaInfo: {
					limitOf: "0",                 //不限地域
					trigger: "0",                 //立即触发
					vehicleMinut: "1",             //离线分钟
					speciallyTrigger: "0",        //特定立即触发
					speciallyVehicleMinut: "1",   //特定离线分钟
					speciallyVehicleZone: "",
					areaList: [], 				  //查询结果表格数据
					pageInfo:{},                  //分页所需信息
					pageNo: 1, 					  //分页返回的当前页数
					areaStatis:false,             //查询结果显示状态
					areaTipStatis:false,          //提示信息显示状态
					areaAddList: [], 		      //添加结果数据
					alarmAreaParam:{
						areaName:'',
						areaType:1,
						customerId:this.$store.state.user.groupid,
						page_index: 1,									
					},
				},
				//监控时段
				alarmPeriodInfo: {
				},
				//监控车辆
				alarmMonitorInfo: {
				},
				//检查列表
				checkList:[],
				messageStr: "",					  // 弹出框内容
				scrollTop: '0'
			};
		},
		watch: {
			'alarmAreaInfo.limitOf': function () {
		       if(this.alarmAreaInfo.limitOf=="0"){
		        	this.alarmAreaInfo.areaStatis = false;
		       }
		    }
        },
        beforeMount(){
			//编辑的时候
			if (this.mode=="1" || this.mode=='2'){
				this.getEditResultList();
			}
        },
		computed: {
			//基本信息激活状态
			stepOneActive: function () {
		        return this.stepIndex===1;
		    },
		    //报警方式激活状态
		    stepTwoActive: function () {
		        return this.stepIndex===2;
		    },
		    //监控区域激活状态
		    stepThreeActive: function () {
		        return this.stepIndex===3;
		    },
		    //监控时段激活状态
		    stepFourActive: function () {
		        return this.stepIndex===4;
		    },
		    //监控车辆激活状态
		    stepFiveActive: function () {
		        return this.stepIndex===5;
		    },
		    //完成激活状态
		    stepSixActive: function () {
		        return this.stepIndex===6;
		    },
		    //上一步按钮是否显示
		    preBtnStatus: function () {
		        return this.stepIndex!==1;
		    },
		    //下一步按钮是否显示
		    nextBtnStatus: function () {
		        return this.stepIndex!==6;
		    },
		    //完成按钮是否显示
		    finishBtnStatus: function () {
		        return this.stepIndex===6;
		    },
		    //车辆离线输入框（第三步）
		     onlimit: function () {
		    	return this.alarmAreaInfo.trigger=='0';
		    },
		     //特定车辆离线输入框（第三步）
		     speciallyOnlimit: function () {
		    	return this.alarmAreaInfo.speciallyTrigger=='0';
		    },
		},
		methods:{
			//下一步事件
			nextStep() {
				if (!this.checkAllInfo())return;
				this.stepIndex += 1;
				if (this.stepIndex > this.stepMaxIndex){
					this.stepMaxIndex = this.stepIndex;
				}
				this.stepOneStatus = this.stepMaxIndex >= 1;
				this.stepTwoStatus = this.stepMaxIndex > 2;
				this.stepThreeStatus = this.stepMaxIndex > 3;
				this.stepFourStatus = this.stepMaxIndex > 4;
				this.stepFiveStatus = this.stepMaxIndex > 5;
			},
			//上一步事件
			preStep() {
				if (this.stepIndex===1){
					return;
				}
				this.stepIndex -= 1;
			},
			//围栏信息获取页码参数
			getFellInfoPageNo(pageNo) { 
				this.alarmAreaInfo.pageNo = pageNo;
				this.alarmAreaInfo.alarmAreaParam.page_index = pageNo;
				this.getFellInfo();
			},
			//查询围栏信息
			fellInfoSearch() { 
				this.alarmAreaInfo.alarmAreaParam.page_index = 1;
				this.getFellInfo();
			},
			//隐藏围栏信息
			hideFellInfo() { 
				this.alarmAreaInfo.areaStatis = false;
			},
			//添加围栏信息
			addFellInfo(index) { 
				let info = Object.assign({},this.alarmAreaInfo.areaList[index]);
				if (info.areaSize ==0){
					info.areaSize = "";
				}
				if (this.alarmAreaInfo.speciallyTrigger=='0'){
		    		info.triggerCount=0;
		    	}else{
		    		info.triggerCount=this.alarmAreaInfo.speciallyVehicleMinut;
		    	}
		    	
		    	let listindex = this.alarmAreaInfo.areaAddList.findIndex(function(value, index, arr) {
						return value.areaId==info.areaId && value.triggerCount ==info.triggerCount;
				})
				
				if (listindex > -1){
					this.openModalMsg("相同区域触发值重复");
					return;
				}
				
				this.alarmAreaInfo.areaAddList.push(info);
			},
			//删除围栏信息
			removeFellInfo(index) { 
				this.alarmAreaInfo.areaAddList.splice(index,1);
			},
			//获取围栏信息
			getFellInfo() { 
				this.loadingstatus.home = true;
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/areas/', {params: this.alarmAreaInfo.alarmAreaParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;	
						if (resInfo.list.length>0){
							this.alarmAreaInfo.areaTipStatis = false;
							this.alarmAreaInfo.areaStatis = true;
							const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
							this.alarmAreaInfo.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
							this.alarmAreaInfo.areaList = resInfo.list;
						}else{
							this.alarmAreaInfo.areaTipStatis = true;
							this.alarmAreaInfo.areaStatis = false;
						}
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus.home = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus.home = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.home = false;
				})
			},
			//删除围栏信息
			removeAlarmPeriod(index) { 
				this.alarmPeriodInfo.alarmPeriodList.splice(index,1);
			},
			//检查信息
			checkAllInfo(){
				let result = true;
				//报警计划名称不能为空
				if (this.stepIndex==1 && this.alarmBaseInfo.alarmPlanName==''){
					this.openModalMsg("报警计划名称不能为空");
					result=false;
				}
				//报警方式
				if (this.stepIndex==2 && this.alarmBaseInfo.alarmLevel=='1' && this.checkAlarmMode()){
					this.openModalMsg("至少选择2种以上的报警方式");
					result=false;
				}
				//报警手机验证
				if (this.stepIndex==2 && this.alarmBaseInfo.alarmLevel=='1' && this.checkAlarmModePhone()){
					this.openModalMsg("手机号填写有错误");
					result=false;
				}
				//监控区域不可以为空
				if (this.stepIndex==3 && this.alarmAreaInfo.limitOf!="0" && this.alarmAreaInfo.areaAddList.length == 0){
					this.openModalMsg("没有添加监控区域");
					result=false;
				}
				//监控时段不可以为空
				if (this.stepIndex==4){
					if (this.alarmPeriodInfo.alarmPeriodList.length == 0){
						this.openModalMsg("没有添加监控时段");
						result=false;
					}else{
						let temp = this.alarmPeriodInfo.alarmPeriodList.filter(function(value, index, arr) {
						   return value.timerangeType == '9' || (value.timerangeType!='9' && value.isexclude=='1');
						})
						if (temp.length==0){
							this.openModalMsg("至少选择一个不限或者包含");
							result=false;
						}
					}
				}
				return result;
			},
			//保存
			saveAllInfo(){
				let areaList=[];
				if(this.alarmAreaInfo.limitOf!=="0"){
					//监控区域
					this.alarmAreaInfo.areaAddList.forEach(function(item, i) {
		                let every = {
		                	areaId:item.areaId,
		                	areaType:"1",
		                	isEnable1:item.triggerCount==0?0:1,
		                	isEnable2:'',
		                	limitValue1:item.triggerCount==0?'':item.triggerCount,
		                	limitValue2:'',
		                	planPointsCal:'',
		                	planAreaHistoryId:item.planAreaHistoryId
		                }
		                areaList.push(every);
		            });
	           }
	            //监控时段
	            let timerangeList=[];
	            this.alarmPeriodInfo.alarmPeriodList.forEach(function(item, i) {
	            	let every = {
	            		timerangeType:item.timerangeType,
	            		dateStart:item.datestart,
	            		dateEnd:item.dateend,
	            		frequency:item.alarmnumvalue,
	            		isAllday:item.isallday,
	            		isExclude:item.isexclude,
	            		limitEnable:item.limitEnable,
	            		timerangeStart:item.timerangestart,
	            		timerangeEnd:item.timerangeend,
	            		upperLimit:item.alarmcountvalue,
	            		weekDay:item.weekday
	            	}
	            	timerangeList.push(every);
	            });
	            //监控车辆
				let vehicleList =[];
				if (this.alarmMonitorInfo.alarmMonitorList){
					this.alarmMonitorInfo.alarmMonitorList.forEach(function(item, i) {
						let every = {
							vehicleId:item.vehicleId
						}
						vehicleList.push(every);
					});
				}
				
				let param={
					isAllVeh:this.alarmMonitorInfo.alarmMonitorMode,					//绑定车辆类型
					groups:JSON.stringify(this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList),  //选择的分支id
					panelIds:this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelSelList,  	//选择的面板id
					planOwnerType:1,
					timeEnable:1,													//有监控时段，必填字段
					almLevel:this.alarmBaseInfo.alarmLevel,							//报警等级
					almType:this.typeid,											//报警种类
					planName:this.alarmBaseInfo.alarmPlanName,						//报警计划名称
					memo:this.alarmBaseInfo.alarmPlanNote,							//报警计划备注
					areaEnable:this.alarmAreaInfo.limitOf,													//区域限制
					customerId:this.$store.state.user.groupid,						//机构ID
					isEnable:this.alarmBaseInfo.alarmPlanStatus,					//计划状态
					mailEnable:this.alarmModeInfo.mailMode?1:0,					    //通过邮件报警
					mailList:this.alarmModeInfo.mailInfo,							//邮件列表
					msgEnable:this.alarmModeInfo.messageMode?1:0,					//通过短信报警
					msgList:this.alarmModeInfo.messageInfo,							//短信报警手机号列表
					telEnable:this.alarmModeInfo.phoneMode?1:0,						//电话报警
					telList:this.alarmModeInfo.phoneInfo,							//手机号列表
					weixinEnable:this.alarmModeInfo.weixinMode?1:0,					//微信报警
					weixinList:this.alarmModeInfo.weixinInfo,					    //微信列表
					isEnable1:this.alarmAreaInfo.limitOf,
					isEnable2:this.alarmAreaInfo.trigger,
					limitValue2:this.alarmAreaInfo.limitOf=="0"?this.alarmAreaInfo.trigger=="0"?"":this.alarmAreaInfo.vehicleMinut:"",
					areaList:this.alarmAreaInfo.limitOf=="0"?[]:areaList,				  //监控区域信息
					timerangeList:timerangeList,									//监控时段信息
					vehicleList:vehicleList,										//监控车辆信息
				} 
				this.loadingstatus.home = true;
				if (this.mode=='0'){
					this.$http.post(process.env.API_ROOT + "/alarm/alarm-plans/almType/"+this.typeid, param)
					.then( res => {
						if(res.body.success){
							this.openModalMsg(OPERATE_SUCCESS);
							this.checkList.push(
								{
									step:"完成",
									message:"添加报警计划成功"
								}
							);
							this.operStatus = true;
						}else{
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus.home = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus.home = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus.home = false;
					})
				}
				if (this.mode=='1' || this.mode=='2'){
					param.id = this.planid;
					this.$http.put(process.env.API_ROOT + "/alarm/alarm-plans/almType/"+this.typeid, param)
					.then( res => {
						if(res.body.success){
							this.openModalMsg(OPERATE_SUCCESS);
							this.checkList.push(
								{
									step:"完成",
									message:"添加报警计划成功"
								}
							);
							this.operStatus = true;
						}else{
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus.home = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus.home = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus.home = false;
					})
				}
				
			},
		    //区域编辑
			getEditResultList(){
				this.loadingstatus.home = true;
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/' + this.planid + '/info', {params: {planId:this.planid}})
					.then((response) => {
						if(response.body.success) {
							let alarmModeInfo = response.body.data;
							this.alarmAreaInfo.limitOf = alarmModeInfo.isenable1;
							this.alarmAreaInfo.trigger = alarmModeInfo.isenable2;
							this.alarmAreaInfo.vehicleMinut = alarmModeInfo.limitValue2;
							
							if (this.alarmAreaInfo.limitOf==1){
								this.getAreaInfo();
							}
						} else {
							this.openModalMsg(response.body.message);
						}
						this.loadingstatus.home = false;
					}, (response) => {
						this.openModalMsg(response.body.message);
						this.loadingstatus.home = false;
					})
					.catch((response) => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus.home = false;
					}	
				)
			},
			//监控区域信息
			getAreaInfo(){
				this.loadingstatus.home = true;
				this.$http.get(process.env.API_ROOT + "/alarm/alarm-plans/"+this.planid+"/areas")
				.then((res) => {
					if(res.body.success) {
						let item = res.data.data;
						let that = this;
						item.forEach(function(item, i) {
			                let every = item;
			                every.triggerCount = item.limitValue1;
			                that.alarmAreaInfo.areaAddList.push(every);
			            });
					} else {
						this.openModalMsg(res.data.message);
					}
					this.loadingstatus.home = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus.home = false;
				}).catch((response) => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.home = false;
				})	
			},
			//报警方式选择
			checkAlarmMode(){
				let count =0;
				if(this.alarmModeInfo.mailMode){
					count++;
				}
				if(this.alarmModeInfo.messageMode){
					count++;
				}
				if(this.alarmModeInfo.weixinMode){
					count++;
				}
				if(this.alarmModeInfo.phoneMode){
					count++;
				}
				if (count>=2){
					return false;
				}else{
					return true;
				}
			},
			//报警方式手机验证
			checkAlarmModePhone(){
				let result = false;
				if(this.alarmModeInfo.messageMode){
					this.alarmModeInfo.messageInfo.split(",").forEach(function(item,index){
						if (!isPhone(item)){
							result = true;
						}
					})
				}
				if(this.alarmModeInfo.phoneMode){
					this.alarmModeInfo.phoneInfo.split(",").forEach(function(item,index){
						if (!isPhone(item)){
							result = true;
						}
					})
				}
				return result;
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#statusAlarmOffline',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#statusAlarmOffline',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
		}
	}
</script>

<style scoped>
	@import '../../../../assets/project/css/iconfont/iconfont.css';
     .grey_box label{
    	font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// PageStatusAlarmOffline.vue?06fa1c2d